import { useContext } from "react";
import { useMutation } from "@apollo/client";
import { useHistory } from 'react-router-dom';
import  {IPerformanceEvaluation} from'../../../interfaces/PerformanceEvaluation.interface'
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { openCollaboratoPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { UPDATE_ACTIVE_PERFORMANCE_EVALUATION, 
          GET_ALL_PERFORMANCES_EVALUATION }
 from "../../../Querys/performanceEvaluation/querys"
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import GreenSwitch from "../../ConfigPayroll/GreenSwitch";
import MenuCrud from './MenuCrud';
import "../css/Card.css"


type PerformanceEvaluationProps ={
  performanceEval:IPerformanceEvaluation ,   
  }

const PerformanceEvaluationCard = ({performanceEval}:PerformanceEvaluationProps) => {
  const { id,step, active,namePerformance,tipoEvaluacion,personasEvaluar,countColEval,progresoReal}= performanceEval
  const history = useHistory();  
  const {dispatch} = useContext(PerformanceEvaluationContext);  
  const [updatePerformanceEv] = useMutation(UPDATE_ACTIVE_PERFORMANCE_EVALUATION, {
    refetchQueries: [{ query: GET_ALL_PERFORMANCES_EVALUATION }]
  });
  

 const updateActive = async (id: any) => {
    await updatePerformanceEv({
      variables: {
        id: id
      }
    });
 }          
 
 const openModalCollaborators = async (id: any) => {
   openCollaboratoPerformanceEvaluationModal(id.toString(),true,true, dispatch)
}          

const openQualificationColl = async (id: any) => {
  history.push(`/evaluacionDesempeñoResultado/${id}`)
  //PerformanceEvaluationResults
} 
 
  return (
    <>
    <Card className='card'>
      <CardContent className="cardContent" >
        <div className='cardTop'>
            <div>
             
             <div className='selectCard'>
             {step === "definicion" && (
              <div><span className='labelCard'>Definición</span></div>    
              )
             }
              {step === "evaluacion" && (
              <div><span className='labelCard'>Evaluación</span></div>    
              )
             }
             {step === "retroalimentacion" && (
              <div><span className='labelCard'>Retroalimentación</span></div>    
              )
             }             
             </div>
          </div>            
          <div className='btnCard'>            
            {/* {CheckPermission("KPIs.Campanias.Activar") && (  */}
              <div className='switchCard'>
                  <span className='actCard'>{active}</span>
                  <GreenSwitch
                    updatePayrollStatus={updateActive}
                    id={id}
                    status={active} 
                    />
                </div>
              {/* )} */}

            <div className='menCard'>
               <MenuCrud 
                id={id} 
                active={active}
                disabledMenu={active==='Activo'?false:true}
                item={performanceEval}/>
            </div>
          </div>
        </div>
        <div className='infoCard'>
          <div className="containerTitleCardPerformance"><span className='titleCard'>{namePerformance}  </span></div>        
        </div>
    
        {step === "definicion" && (
          <div className='definirCardEv'>
            <div className='definirContain-Col'  onClick={() =>active==='Activo'? openModalCollaborators(id):null}>
              <div><span className='definirTxt'>{`${personasEvaluar}`}</span></div>                
              <div className='contDefMsj'              
              ><span className='msjDefCard'>Personas por evaluar</span> </div>
            </div>
            <div className="v-lineCard"></div>
            <div className='definirContain'>
              <div><span className='definirTxt'>{`${tipoEvaluacion}`}&deg;</span></div>
              <div className='contDefMsj'><span className='msjDefCard'>Roles a evaluar</span> </div>
            </div>
          </div>)
        }
      { step !== "definicion" && (
        <div className='evContain'>
          <div className='definirContain-Col'  onClick={() => (step==='evaluacion' && active==='Activo')?openModalCollaborators(id): openQualificationColl(id)}>       
            <div><span className='evalTxt'>{`${personasEvaluar - countColEval} de ${personasEvaluar} `}</span>  </div>
            <div className='contMsjEvaluar'><span className='msjEvaluar'>Personas por </span> </div>
            <div className='contMsjEvaluar'><span className='msjEvaluar'>evaluar</span> </div>
          </div>
           <div className="ev-line"></div>
            <div className='definirContain'>
              <div><span className='evalTxt'>{`${tipoEvaluacion}`}&deg;</span></div>
              <div className='contDefMsj'><span className='msjDefCard'>Roles a evaluar</span> </div>
            </div>
           <div className="ev-line"></div>
           <div className='definirContain'>
           {progresoReal !==0 ?
             <div className='evalPct'><span className='evalTxt'>{progresoReal ===100 ?`${progresoReal} %` :`${progresoReal.toFixed(2)}%`}</span></div>
             :
             <div  className='evalPct'><span className='evalTxt'>{`0%`}</span></div>
           }
             <div><span className='msjEvaluar'>Progreso</span></div>
             <div><span className='msjEvaluar'>real</span> </div>
           </div>             
         </div>       
          )
        }
      </CardContent>
    </Card>
  </>
  )
}

export default PerformanceEvaluationCard

